import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 110,
	height: 28,
	viewBox: "0 0 110 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M80.8494 2.5597C80.8494 1.48126 81.7969 0.606491 82.9658 0.606491H107.373C108.542 0.606491 109.49 1.48126 109.49 2.5597V25.9198C109.49 26.9986 108.542 27.873 107.373 27.873H82.9658C81.7969 27.873 80.8494 26.9986 80.8494 25.9198V2.5597Z",
			fill: "#006699"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.675049 23.446H12.6276V19.7338H5.00053V5.57058H0.675049V23.446Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.679 23.446V11.134H14.3532V23.446H18.679ZM16.5161 9.45294C18.0246 9.45294 18.9636 8.50749 18.9636 7.32522C18.9355 6.11745 18.0246 5.1986 16.5449 5.1986C15.0649 5.1986 14.0974 6.11745 14.0974 7.32522C14.0974 8.50749 15.0362 9.45294 16.4879 9.45294H16.5161Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.6875 23.446H25.0134V16.5702C25.0134 16.2023 25.0415 15.8346 25.1559 15.5716C25.4685 14.8367 26.1802 14.0753 27.3753 14.0753C28.9408 14.0753 29.567 15.2047 29.567 16.8588V23.446H33.8925V16.3863C33.8925 12.6044 31.7581 10.8447 28.912 10.8447C26.5785 10.8447 25.5538 12.0787 24.9846 12.9192H25.0135V11.134H20.6876C20.7444 12.2893 20.6875 23.446 20.6875 23.446Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.995 5.57058H35.6689V23.446H39.995V19.4543L41.0761 18.1668L44.4629 23.446H49.7845L44.093 15.8033L49.0732 10.6035H43.8654C43.8654 10.6035 40.3081 15.2557 39.995 15.8073V5.57058Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M61.353 18.3103C61.4098 17.994 61.4954 17.3874 61.4954 16.7017C61.4954 13.5189 59.7875 10.288 55.2913 10.288C50.4815 10.288 48.2618 13.8865 48.2618 17.1502C48.2618 21.1871 50.9654 23.7083 55.6896 23.7083C57.568 23.7083 59.3037 23.446 60.7268 22.8944L60.1574 20.1917C58.9908 20.5579 57.7955 20.7408 56.3158 20.7408C54.2952 20.7408 52.5309 19.9564 52.3884 18.2841L61.353 18.3096V18.3103ZM52.3602 15.5417C52.4739 14.491 53.2139 12.9411 55.0637 12.9411C57.0269 12.9411 57.4826 14.5962 57.4826 15.5417H52.3602Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M72.173 5.57057V11.7584H72.1162C71.49 10.8924 70.1806 10.3146 68.4451 10.3146C65.1152 10.3146 62.184 12.8358 62.2122 17.1426C62.2122 21.135 64.859 23.7349 68.1602 23.7349C69.9531 23.7349 71.6606 22.9993 72.5143 21.5809H72.5999L72.7706 23.446H76.6128C76.5558 22.5792 76.4985 21.0822 76.4985 19.6117V5.57057H72.173ZM72.173 17.747C72.173 18.0618 72.1445 18.3773 72.0874 18.6397C71.8317 19.7691 70.8068 20.5568 69.555 20.5568C67.7619 20.5568 66.5951 19.1913 66.5951 17.0377C66.5951 15.0156 67.5914 13.3874 69.5832 13.3874C70.9206 13.3874 71.8599 14.2538 72.1162 15.3304C72.173 15.5672 72.173 15.8299 72.173 16.066V17.747Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M89.5312 23.4314V11.119H85.2053V23.4314H89.5312ZM87.3682 9.43799C88.8768 9.43799 89.8157 8.49254 89.8157 7.311C89.7876 6.10286 88.8768 5.18364 87.3969 5.18364C85.9171 5.18364 84.9496 6.10286 84.9496 7.311C84.9496 8.49254 85.8883 9.43799 87.34 9.43799H87.3682Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.9249 23.4314H96.2508V16.5557C96.2508 16.1877 96.2789 15.8201 96.3931 15.557C96.7058 14.8218 97.4176 14.0603 98.6127 14.0603C100.178 14.0603 100.804 15.1894 100.804 16.8446V23.4314H105.13V16.3717C105.13 12.5899 102.996 10.8301 100.149 10.8301C97.8157 10.8301 96.7912 12.0641 96.222 12.9046H96.2509V11.119H91.925C91.9818 12.2743 91.9249 23.4314 91.9249 23.4314Z",
			fill: "white"
		})
	]
});
export default SvgLinkedin;
